var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { clickable: !_vm.opened },
      on: {
        click: function($event) {
          !_vm.opened ? _vm.toggleView() : null
        }
      }
    },
    [
      _c(
        "base-card",
        {
          key: _vm.healthVarsKey,
          staticClass: "mb-4 history-wrapper-card",
          style: { "background-color": _vm.color, "border-color": _vm.color },
          attrs: {
            overflowVisible: _vm.overflowVisible,
            title: _vm.title,
            hideTitle: _vm.hideTitle,
            flowRoot: "",
            marginBottom: _vm.opened ? 3 : 0
          },
          scopedSlots: _vm._u(
            [
              !_vm.hideButtons & !_vm.showBtnLeft
                ? {
                    key: "right-button",
                    fn: function() {
                      return [
                        _vm.openBtnVisible
                          ? _c("base-button", [_vm._v(_vm._s(_vm.btnTitle))])
                          : _vm._e(),
                        _vm.accessBtnUrl || _vm.sectionPath
                          ? _c(
                              "base-button",
                              {
                                class: { "ml-2": _vm.openBtnVisible },
                                attrs: { white: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.sectionPath
                                      ? _vm.goToSection(_vm.sectionPath)
                                      : _vm.accessBtnAction(_vm.accessBtnUrl)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("login-wrd")))]
                            )
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          )
        },
        [
          _vm._v(" "),
          !_vm.hideButtons && _vm.showBtnLeft
            ? _c(
                "div",
                { staticClass: "left-btn mt-3" },
                [
                  _vm.openBtnVisible
                    ? _c("base-button", [_vm._v(_vm._s(_vm.btnTitle))])
                    : _vm._e(),
                  _vm.accessBtnUrl || _vm.sectionPath
                    ? _c(
                        "base-button",
                        {
                          class: { "ml-2": _vm.openBtnVisible },
                          attrs: { white: "" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.sectionPath
                                ? _vm.goToSection(_vm.sectionPath)
                                : _vm.accessBtnAction(_vm.accessBtnUrl)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("login-wrd")))]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.hideButtons && _vm.opened
            ? _c(
                "button",
                {
                  staticClass: "close close-btn-history-wrapper",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.closeCard.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.opened ? _vm._t("default") : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cc3c194", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cc3c194","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/ClinicHistorySectionWrapper.vue
// module id = 2983
// module chunks = 2 38 47